export default __webpack_public_path__ + "static/pwa-expertise-13b80587c38f618fa47e2b30a6d06049.webp";